// // スタイルシート（Sass）を読み込む
import '../css/top.scss';

/* ---------------------------------------------------------------------------
 * TOP Script
 * --------------------------------------------------------------------------- */

jQuery(function($){
    var slider = $(".slider");
    if (slider.length) {
        slider.slick({
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: '10%'
        });
    }
});
